import {useState} from "react";
import btnScroll from "../../assets/images/home/btn_scroll.png";
import charIndexOverlayDefault from "../../assets/images/charactor/index/char_index_overlay_default.png";
import charIndexOverlayHover from "../../assets/images/charactor/index/char_index_overlay_hover.png";
import charIndexOverlayRight from "../../assets/images/charactor/index/char_index_overlay_right.png";
import charIndexLineXs2x from "../../assets/images/charactor/index/char_index_line_xs@2x.png";
import charIndexLineLong2x from "../../assets/images/charactor/index/char_index_line_long@2x.png";
import charIndexBtnMoreDefault from "../../assets/images/charactor/index/char_index_btn_more_default.png";
import charIndexBtnMoreDefault2x from "../../assets/images/charactor/index/char_index_btn_more_default@2x.png";
import charIndexBtnMoreHover from "../../assets/images/charactor/index/char_index_btn_more_hover.png";
import charIndexBtnMoreHover2x from "../../assets/images/charactor/index/char_index_btn_more_hover@2x.png";

const VISIBLE_ROLE_COUNT = 4;

export default function RolesSection({
    roles,
    activeRoleIndex,
    onRoleChange,
    onRoleDetailOpen
}) {
    const [firstRoleIndex, setFirstRoleIndex] = useState(0);

    if (!roles.length) {
        return (
            <section className="section roles" id="char" data-nav="角色介绍">
                <div className="role-empty">角色档案整理中</div>
            </section>
        );
    }

    const visibleRoles = Array.from(
        {length: Math.min(VISIBLE_ROLE_COUNT, roles.length)},
        (_, offset) => {
            const roleIndex = (firstRoleIndex + offset) % roles.length;
            return {role: roles[roleIndex], roleIndex};
        }
    );
    const hasActiveRole = Number.isInteger(activeRoleIndex)
        && activeRoleIndex >= 0
        && activeRoleIndex < roles.length;

    const shiftRoles = function (offset) {
        const nextFirstRoleIndex = (firstRoleIndex + offset + roles.length) % roles.length;
        setFirstRoleIndex(nextFirstRoleIndex);
        onRoleChange(nextFirstRoleIndex);
    };

    return (
        <section
            className="section roles"
            id="char"
            data-nav="角色介绍"
        >
            <div className="role-card-grid">
                {visibleRoles.map(({role, roleIndex}) => (
                    <button
                        key={role.name}
                        className={activeRoleIndex === roleIndex ? "role-more-card active" : "role-more-card"}
                        type="button"
                        aria-pressed={activeRoleIndex === roleIndex}
                        onClick={() => {
                            if (typeof onRoleDetailOpen === "function") {
                                onRoleDetailOpen(roleIndex);
                                return;
                            }
                            onRoleChange(roleIndex);
                        }}
                    >
                        <picture className="role-card-person-picture">
                            {role.indexImg2x ? <source media="(min-width: 1921px)" srcSet={role.indexImg2x} /> : null}
                            <img
                                className="role-card-person"
                                src={role.indexImg || role.personImg}
                                style={{transformOrigin: role.indexTransformOrigin || "50% 25%"}}
                                alt=""
                                aria-hidden="true"
                            />
                        </picture>
                        <img className="role-card-overlay default" src={charIndexOverlayDefault} alt="" aria-hidden="true" />
                        <img className="role-card-overlay hover" src={charIndexOverlayHover} alt="" aria-hidden="true" />
                        <img className="role-card-overlay-right" src={charIndexOverlayRight} alt="" aria-hidden="true" />

                        {role.indexDeco ? (
                            <span className="role-card-name-deco-wrap">
                                <picture>
                                    {role.indexDeco2x ? <source media="(min-width: 1921px)" srcSet={role.indexDeco2x} /> : null}
                                    <img className="role-card-name-deco" src={role.indexDeco} alt={role.englishName} />
                                </picture>
                            </span>
                        ) : null}

                        <span className="role-card-title-row">
                            <picture className="role-card-title-name-picture">
                                {role.indexName2x ? <source media="(min-width: 1921px)" srcSet={role.indexName2x} /> : null}
                                <img className="role-card-title-name" src={role.indexName} alt={role.name} />
                            </picture>
                            <img className="role-card-title-line short" src={charIndexLineXs2x} alt="" aria-hidden="true" />
                            <img className="role-card-title-line long" src={charIndexLineLong2x} alt="" aria-hidden="true" />
                        </span>

                        {role.cardLines && role.cardLines.length ? (
                            <span className={role.cardLines.length === 1 ? "role-card-lines role-card-lines--single" : "role-card-lines"}>
                                {role.cardLines.map((line) => (
                                    <span key={line}>{line}</span>
                                ))}
                            </span>
                        ) : null}

                    </button>
                ))}
            </div>

            <button
                className="role-card-more"
                type="button"
                onClick={() => {
                    if (typeof onRoleDetailOpen === "function") {
                        onRoleDetailOpen(0);
                        return;
                    }
                    onRoleChange(0);
                }}
            >
                <picture className="default">
                    <source media="(min-width: 1921px)" srcSet={charIndexBtnMoreDefault2x} />
                    <img src={charIndexBtnMoreDefault} alt="更多信息" />
                </picture>
                <picture className="active">
                    <source media="(min-width: 1921px)" srcSet={charIndexBtnMoreHover2x} />
                    <img src={charIndexBtnMoreHover} alt="" />
                </picture>
            </button>

            <div className="role-more-footer">
                <strong aria-hidden="true">CHARACTER INTRODUCTION</strong>
                <div className="role-more-pager">
                    <button type="button" aria-label="上一组角色" onClick={() => shiftRoles(-1)}>&lsaquo;</button>
                    <span>
                        {String(hasActiveRole ? activeRoleIndex + 1 : 0).padStart(2, "0")}
                        <small>/ {String(roles.length).padStart(2, "0")}</small>
                    </span>
                    <button type="button" aria-label="下一组角色" onClick={() => shiftRoles(1)}>&rsaquo;</button>
                </div>
            </div>

            <div className="home-scroll-btn" aria-hidden="true">
                <img src={btnScroll} alt="" aria-hidden="true"/>
            </div>
        </section>
    );
}
